import FormErrorsHandlerHOC from './FormErrorsHandlerHOC';

export default {
  FormErrorsHandlerHOC,
};



// WEBPACK FOOTER //
// ./src/components/HOCs/index.js